const DEFAULT_PREVIEW_LIMIT = 5;

export function normalizeRecallConversationIdentifier(value) {
  const withoutScheme = String(value || "")
    .trim()
    .replace(/^(?:whatsapp:|tel:)/i, "");
  const digits = withoutScheme.replace(/\D+/g, "");
  return digits ? `whatsapp:+${digits}` : "";
}

export function getRecallConversationRoleLabel(role) {
  if (role === "user") return "Patient";
  if (role === "assistant") return "Assistant";
  if (role === "human") return "Clinic";
  return "Message";
}

export function prepareRecallConversationMessages(
  rows,
  limit = DEFAULT_PREVIEW_LIMIT,
) {
  if (!Array.isArray(rows)) return [];

  const chronological = [...rows].sort(
    (left, right) =>
      Date.parse(left?.created_at || "") - Date.parse(right?.created_at || ""),
  );

  return chronological.slice(-Math.max(0, limit));
}

